const SET_HOME_PAGE = 'SET_HOME_PAGE';

export { SET_HOME_PAGE };
